import React from "react";
import ImageFrame from "./Imageframe";
import { CAPABILITIES, CAPABILITIES_HEAD } from "./Gpmsdata";
 
const GPMSCapabilities = () => (
  <section className="gp-caps">
    <div className="gp-container">
      <header className="gp-caps__head">
        <span className="gp-pill">{CAPABILITIES_HEAD.badge}</span>
        <h2 className="gp-caps__title">{CAPABILITIES_HEAD.title}</h2>
        <p className="gp-caps__sub">{CAPABILITIES_HEAD.subtitle}</p>
      </header>
 
      <div className="gp-caps__list">
        {CAPABILITIES.map((cap, i) => (
          <article
            key={cap.id}
            className={`gp-cap ${i % 2 === 1 ? "gp-cap--reverse" : ""}`}
          >
            <div className="gp-cap__media">
              <ImageFrame src={cap.image} alt={cap.title} tag={cap.tag} />
            </div>
 
            <div className="gp-cap__body">
              <span className="gp-cap__num" aria-hidden="true">
                {cap.number}
              </span>
              <h3 className="gp-cap__title">{cap.title}</h3>
              <span className="gp-underline" />
              <p className="gp-cap__desc">{cap.desc}</p>
              <a href={`#${cap.id}-details`} className="gp-btn">
                EXPLORE MORE <span aria-hidden="true">→</span>
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
 
export default GPMSCapabilities;